/**
 * Created by evgenijsenkevic on 23/7/25
 */

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    STICKERS_COLLECTION_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.STICKERS_COLLECTION_COLOR
    },

    STICKERS_AVAILABLE_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.STICKERS_AVAILABLE_COLOR
    },

    STICKERS_PROGRESS_BAR_TEXT: {
        size: 40
    },

    STICKER_JOKER_BUTTON_TEXT: {
        size: 48,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    }
});

cleverapps.overrideStyles(cleverapps.styles.StickersBookJokerView, {
    withBillet: true
});

cleverapps.overrideStyles(cleverapps.styles.StickersBookWindow, {
    window: {
        padding: {
            top: 10
        }
    },

    size: [
        { width: 830, height: 1370 },
        { width: 1520, height: 950 },
        { width: 1520, height: 950 }
    ],

    fg: undefined,

    scroll: {
        size: [
            { width: 860, height: 1200 },
            { width: 1483, height: 840 },
            { width: 1483, height: 840 }
        ],
        position: [
            {
                x: { align: "center" },
                y: { align: "center", dy: -70 }
            },
            {
                x: { align: "center", dx: 2 },
                y: { align: "center", dy: -60 }
            },
            {
                x: { align: "center", dx: 2 },
                y: { align: "center", dy: -60 }
            }
        ],

        barPadding: {
            sidePadding: 10
        }
    },

    progressView: {
        width: 360,
        verticalWidth: 340,
        position: [
            { x: { align: "center", dx: 36 }, y: { align: "top", dy: -48 } },
            { x: { align: "center", dx: 50 }, y: { align: "top", dy: -54 } },
            { x: { align: "center", dx: 50 }, y: { align: "top", dy: -54 } }
        ],
        joker: {
            x: { align: "left", dx: -40 },
            y: { align: "center" }
        },
        text: {
            dy: 0
        }
    },

    collectionsAmount: {
        position: [
            { x: { align: "left", dx: 20 }, y: { align: "top", dy: -30 } },
            { x: { align: "left", dx: 35 }, y: { align: "top", dy: -40 } },
            { x: { align: "left", dx: 35 }, y: { align: "top", dy: -40 } }
        ],
        bg: {
            height: 67
        }
    },

    stickersAmount: {
        position: [
            { x: { align: "left", dx: 40 }, y: { align: "top", dy: -40 } },
            { x: { align: "left", dx: 280 }, y: { align: "top", dy: -40 } },
            { x: { align: "left", dx: 280 }, y: { align: "top", dy: -40 } }
        ],
        bg: {
            height: 67
        }
    },

    jokers: {
        position: [
            { x: { align: "right", dx: -20 }, y: { align: "top", dy: -28 } },
            { x: { align: "right", dx: -30 }, y: { align: "top", dy: -40 } },
            { x: { align: "right", dx: -30 }, y: { align: "top", dy: -40 } }
        ]
    },

    jokerAnimation: {
        duration: 1.2
    }
});

cleverapps.overrideStyles(cleverapps.styles.StickersCollectionIcon, {
    icon: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 80 }
    },

    textBg: undefined,

    title: {
        maxWidth: 220,
        maxHeight: 60,
        x: { align: "center" },
        y: { align: "bottom", dy: 120 }
    },

    margin: -110,

    badge: {
        x: { align: "right", dx: 10 },
        y: { align: "top", dy: 10 },
        text: undefined
    },

    underline: {
        x: { align: "center" },
        y: { align: "top", dy: 2 }
    },

    prizebar: {
        x: { align: "center", dx: 3 },
        y: { align: "center" },
        width: 170,
        prize: {
            x: { align: "right", dx: 55 },
            y: { align: "center" }
        },
        text: {
            dy: -1
        }
    },

    collectAnimation: {
        duration: 2.95
    }
});

cleverapps.overrideStyles(cleverapps.styles.StickersCollectionWindow, {
    size: [
        { width: 900, height: 1200 },
        { width: 900, height: 1200 },
        { width: 900, height: 1200 }
    ],
    puzzlesComponent: {
        x: { align: "center" },
        y: { align: "center", dy: -50 }
    },
    prize: {
        position: [
            { x: { align: "center", dx: -109 }, y: { align: "top", dy: -37 } },
            { x: { align: "center", dx: -109 }, y: { align: "top", dy: -37 } },
            { x: { align: "center", dx: -109 }, y: { align: "top", dy: -37 } }
        ],
        width: 465
    },
    finish: {
        position: [
            { x: { align: "center", dx: -109 }, y: { align: "top", dy: -37 } },
            { x: { align: "center", dx: -109 }, y: { align: "top", dy: -37 } },
            { x: { align: "center", dx: -109 }, y: { align: "top", dy: -37 } }
        ]
    },
    jokers: {
        position: [
            { x: { align: "right", dx: -85 }, y: { align: "top", dy: -30 } },
            { x: { align: "right", dx: -85 }, y: { align: "top", dy: -30 } },
            { x: { align: "right", dx: -85 }, y: { align: "top", dy: -30 } }
        ]
    },
    tooltip: {
        y: { align: "bottom", dy: -40 }
    },
    highlight: {
        x: { align: "center", dx: -5 },
        y: { align: "center", dy: -13 }
    },
    text: {
        dy: 0
    }
});

cleverapps.overrideStyles(cleverapps.styles.StickersRewardWindow, {
    stickers: {
        margin: {
            x: 150,
            y: 200
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.StickerView, {
    text: {
        x: { align: "center", dx: 0 },
        y: { align: "top", dy: 135 }
    },
    points: {
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: 50 }
    },
    badge: {
        x: { align: "right", dx: 25 },
        y: { align: "top", dy: 35 },
        text: {
            x: { align: "center" },
            y: { align: "center" },
            maxWidth: 100
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.StickersCompletedWindow, {
    layout: {
        x: { align: "center" },
        y: { align: "center", dy: -300 },
        margin: 20
    },
    puzzles: {
        x: { align: "center" },
        y: { align: "center", dy: 160 }
    }
});